import React from 'react';
import { motion } from 'framer-motion';
import { Box, Container, Typography, Grid, Card, CardContent, Chip } from '@mui/material';
import { Phone, Email as Mail, LocationOn as MapPin } from '@mui/icons-material';

export default function Contact() {
  return (
    <Box component="section" id="contact" sx={{ py: { xs: 10, md: 12 } }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip
              label="Contact Us"
              sx={{
                mb: 2,
                bgcolor: 'rgba(30, 91, 92, 0.1)',
                color: 'rgba(30, 91, 92, 1)',
                fontWeight: 500
              }}
            />
            <Typography
              variant="h3"
              component="h2"
              sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}
            >
              Get in Touch
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: 'text.secondary', maxWidth: '32rem', mx: 'auto' }}
            >
              Contact SHREE CONSULTANCY for expert services in Rajkot. We're
              here to help!
            </Typography>
          </Box>
        </motion.div>

        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <Card sx={{ mb: 3 }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', mb: 3 }}>
                    Contact Information
                  </Typography>
                  
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(30, 91, 92, 0.1)',
                        color: 'rgba(30, 91, 92, 1)',
                        flexShrink: 0
                      }}
                    >
                      <MapPin sx={{ fontSize: 20 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                        Office Address
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        The Accord, Opp. Park Avenue,<br />
                        Near Arjun Jewellers,<br />
                        Nana Mauva Road, Rajkot - 360004
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(30, 91, 92, 0.1)',
                        color: 'rgba(30, 91, 92, 1)',
                        flexShrink: 0
                      }}
                    >
                      <Phone sx={{ fontSize: 20 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                        Phone
                      </Typography>
                      <Typography
                        component="a"
                        href="tel:+918758485159"
                        variant="body2"
                        sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                      >
                        +91 87584 85159
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'rgba(30, 91, 92, 0.1)',
                        color: 'rgba(30, 91, 92, 1)',
                        flexShrink: 0
                      }}
                    >
                      <Mail sx={{ fontSize: 20 }} />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                        Email
                      </Typography>
                      <Typography
                        component="a"
                        href="mailto:nikhilamareliya@gmail.com"
                        variant="body2"
                        sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                      >
                        nikhilamareliya@gmail.com
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              <Card>
                <CardContent sx={{ p: 4 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', mb: 3 }}>
                    Business Hours
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Monday - Friday
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        9:30 AM - 7:00 PM
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Saturday
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        9:30 AM - 1:30 PM
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Sunday
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        Closed
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}